module.exports = __webpack_public_path__ + "img/KinokoTable40.1d0d77ce.jpg";